import React, { ReactNode } from 'react'
import { QuestionProps } from '../Question'
import {
	FreeResponse as FreeResponseType,
	ClientFields,
	FreeResponseAnswer,
	variantTypes,
} from '@mission.io/question-toolkit'
import TeacherFreeResponse from './Teacher'
import StudentFreeResponse from './Student'
import { Container } from '../../assets/styles'
import { StudentResponse } from '../../model/general'

export interface FreeResponseProps extends QuestionProps {
	question: FreeResponseType<ClientFields>
}
/**
 * A component for free response question form. It has a Teacher and Student view.
 * @param {FreeResponseProps} props
 * @returns {JSX.Element}
 */
export const FreeResponse = ({
	question,
	requestId,
	review,
	textToSpeech,
	sendMessage,
	teacherQuestion = false,
	readOnly = false,
	onChange,
	...props
}: FreeResponseProps): ReactNode => {
	if (
		!question ||
		(props.studentResponse &&
			props.studentResponse.answer.type !== variantTypes.FREE_RESPONSE)
	) {
		return null
	}

	const studentResponse = props.studentResponse as
		| StudentResponse<FreeResponseAnswer>
		| null
		| undefined

	return (
		<Container className={props.className}>
			{teacherQuestion ? (
				<TeacherFreeResponse
					onChange={onChange}
					readOnly={readOnly}
					question={question}
					studentResponse={studentResponse}
					questionIndex={props.questionIndex}
					isQuestionAnalytics={props.isQuestionAnalytics}
					studentName={props.studentName}
					onRequestClose={props.onRequestClose}
					isCollapsibleQuestion={props.isCollapsibleQuestion}
					buttonAction={props.buttonAction}
					autoFocus={props.autoFocus}
				/>
			) : (
				<StudentFreeResponse
					review={review}
					requestId={requestId}
					question={question}
					studentResponse={studentResponse}
					questionIndex={props.questionIndex}
					parentRef={props.parentRef}
					textToSpeech={textToSpeech}
					sendMessage={sendMessage}
				/>
			)}
		</Container>
	)
}

export default FreeResponse
